const contentState = (
  currentState = {
    showDevState: window.localStorage.showDevState === 'true' ? true : false,
    hotkeysAdded: false
  },
  action
) => {
  switch (action.type) {
    case 'TOGGLE_DEVSTATE_DISPLAY':
      return {
        ...currentState,
        showDevState: !currentState.showDevState
      };
    default:
      return currentState;
  }
};
export default contentState;
